/** @format */

import APIRequest from "../utils/APIRequest";

export default class User {
  static getMyWaba = async () => {
    return await APIRequest.set("v1/waba", "GET");
  };

  static getCost = async (phoneNumber) => {
    return await APIRequest.set(
      `v1/waba/costbyphonenumber/${phoneNumber}`,
      "GET"
    );
  };

  static getMyWabaByWABA = async (id) => {
    return await APIRequest.set(`v1/waba/bytenantid/${id}`, "GET");
  };
  

  static getWabaId = async (id) => {
    return await APIRequest.set(`v1/waba/${id}`, "GET");
  };

  static addWaba = async (body) => {
    return await APIRequest.set("v1/waba", "POST", body);
  };

  static updateWaba = async (body, id) => {
    return await APIRequest.set(`v1/waba/${id}`, "PUT", body);
  };

  static deleteWaba = async (id) => {
    return await APIRequest.set(`v1/waba/${id}`, "DELETE");
  };
}
